module.exports = require("prismjs/components/prism-perl.js");